import React, { Component } from 'react';
import { pure, compose, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import BoxPublished from '../../../../core/BoxPublished';
import {
  StyledContainerPrincipal,
  StyledArticleColumn2,
  StyledOptionsSocialMedia,
  StyledTagCategoryArticle,
  StyledContainerColumn
} from '../../style';
import Template from '../Template';
import ModalEmail from '../../ModalEmail';

class TemplateBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalMail: false
    };
  }

  onClickShareBtn = () => {
    this.setState({
      showModalMail: true
    });
  };

  closeModal = () => {
    this.setState({
      showModalMail: false
    });
  };

  render() {
    const {
      id,
      baseContentType,
      favorite,
      author,
      dateFrom,
      socialInfo,
      like,
      onLike,
      tags,
      onFavorite,
      likesNumber,
      hastoken
    } = this.props;

    const { showModalMail } = this.state;

    return (
      <React.Fragment>
        <StyledContainerPrincipal>
          <StyledContainerColumn>
            {author && <Template author={author.user.name} {...this.props} />}
            <StyledArticleColumn2>
              <BoxPublished author={author} publishDate={dateFrom}>
                {tags &&
                  tags.map((tag, i) => (
                    <StyledTagCategoryArticle
                      key={`${tag.name + i}`}
                      category={tag.name}
                    />
                  ))}
              </BoxPublished>
              <StyledOptionsSocialMedia
                numberIcon={socialInfo && socialInfo.numberOfComments}
                activeLike={like}
                activeFavorite={favorite}
                likesNumber={likesNumber}
                onLike={() => onLike(id)}
                onFavorite={() => onFavorite(id)}
                onShare={this.onClickShareBtn}
                hastoken={hastoken}
              />
            </StyledArticleColumn2>
          </StyledContainerColumn>
        </StyledContainerPrincipal>
        {showModalMail && (
          <ModalEmail
            closeModal={this.closeModal}
            baseContentId={id}
            contentType={baseContentType}
          />
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  setPropTypes({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mediaType: PropTypes.string,
    baseContentType: PropTypes.string,
    favorite: PropTypes.bool,
    dateFrom: PropTypes.instanceOf(Date),
    author: PropTypes.shape({
      user: PropTypes.shape({ name: PropTypes.string }),
      association: PropTypes.shape({ name: PropTypes.string })
    }),
    socialInfo: PropTypes.shape({ numberOfComments: PropTypes.number }),
    like: PropTypes.bool,
    likesNumber: PropTypes.number,
    onLike: PropTypes.func,
    tags: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
    onFavorite: PropTypes.func,
    onShare: PropTypes.func,
    hastoken: PropTypes.bool
  }),
  pure
)(TemplateBase);
